<template>
  <div class="articles">
    <PageTitle v-bind:title="'Search articles'" />
    <b-container fluid="xxl" class="mt-5">
      <b-row>
        <b-col>
          <div v-if="$store.state.user.settings.isDictionaryFiltered" class="mb-3 text-orange">
            <b-icon icon="exclamation-circle-fill" aria-hidden="true"></b-icon>
            Articles are filtered by personal preference for dictionary set in user settings
            ({{ $store.getters.getDictionariesByIds($store.state.user.settings.dictionaries).map(dictionary => dictionary.acronym).join(', ') }})
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4 text-center">
        <b-col>
          <input
            class="rounded-l-full w-full py-6 px-6 p-2 text-gray-700 leading-tight focus:outline-none w-100 form-control"
            id="search"
            type="text"
            placeholder="Search"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <span v-if="articles.length">
            <p v-for="article in articles" :key="article.id">
              <router-link :to="{ name: 'Article', params: { id: article.id }}">
                {{ article.mainLemma.lemmaForm }} <span v-if="article.dictionary ">
                  ({{ article.dictionary.acronym }} - {{ article.dictionary.title }})
                </span>
              </router-link>
            </p>
          </span>
          <span v-else>No results</span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  let timer
  import { mapState } from 'vuex'

  import PageTitle from '@/components/PageTitle.vue'

  export default {
    name: 'Articles',
    data() {
      this.$store.state.article.articles = []
      return {
        query: "",
      }
    },
    components: {
      PageTitle
    },
    mounted() {
      this.$store.state.article.articles = []
      this.$store.state.article.article = null
    },
    computed: {
      ...mapState({
        articles: state => state.article.articles,
        userSettings: state => state.user.settings
      })
    },
    watch: {
      "userSettings"(){
        this.getSearchResults()
      }
    },
    methods: {
      getSearchResults(){
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.$store.dispatch('searchArticles', {
            query: this.query.toLowerCase(),
            dictionaries: this.userSettings.dictionaries
          })
        }, 400)
      }
    }
  }
</script>
